import type { INftData, IReqNftList, IResNftList } from '../types';
import type { SuiClient } from '@mysten/sui.js/client';

export const getNftList = async (
  request: IReqNftList,
): Promise<IResNftList> => {
  try {
    const objs = await (global._CLIENT as SuiClient).getOwnedObjects({
      owner: request.address,
      filter: {
        MatchNone: [
          { StructType: '0x2::coin::Coin' },
          { StructType: '0x3::staking_pool::StakedSui' },
        ],
      },
      options: {
        showDisplay: true,
        showType: true,
      },
    });

    return {
      nextPage: objs.nextCursor || undefined,
      list: objs.data
        .filter((item) => item.data)
        .map(
          (item) =>
            ({
              address: item.data?.objectId as string,
              title: item.data?.display?.data?.name,
              desc: item.data?.display?.data?.description,
              img: item.data?.display?.data?.image_url,
              link:
                item.data?.display?.data?.link ||
                item.data?.display?.data?.project_url,
            }) as INftData,
        ),
    };
  } catch (error) {
    throw new Error(`${error}`);
  }
};
